import React, { useMemo, useState } from 'react'

import PropertyRateOption from './PropertyRateOption'
import PropertyRefundabilitySelector from './PropertyRefundabilitySelector'

interface Props {
  lpcOffer?: App.HotelOffer
  rates: Array<App.PropertyRate>
  optionNumber: number
  showOptionLabel: boolean
  roomListId: string
  roomPosition: number
  rateListId: string
  propertyTimezone: string
}

/**
 * Merged variant that combines property rates with radio button selection.
 *
 * New UI structure: Radio selector for rates (by rate ID) injected into PropertyRateOption where the cancellation policy would normally go
 */
function PropertyRateOptionMerged(props: Props) {
  const {
    lpcOffer,
    rates,
    optionNumber,
    showOptionLabel,
    roomListId,
    roomPosition,
    rateListId,
    propertyTimezone,
  } = props

  // Default to first rate in the group
  const defaultRateId = rates[0]?.rateId
  const [selectedRateId, setSelectedRateId] = useState<string | undefined>(defaultRateId)

  const activeRate = useMemo(() => {
    return rates.find(rate => rate.rateId === selectedRateId) || rates[0]
  }, [rates, selectedRateId])

  const hasChoice = rates.length > 1

  if (!activeRate) {
    return null
  }

  const cancellationPolicyContentOverride =
    hasChoice ?
        <PropertyRefundabilitySelector
          rates={rates}
          selectedRateId={selectedRateId}
          onChange={setSelectedRateId}
          propertyTimezone={propertyTimezone}
        /> :
      undefined

  return <PropertyRateOption
    lpcOffer={lpcOffer}
    rate={activeRate}
    optionNumber={optionNumber}
    ratePosition={activeRate.defaultOrder + 1}
    showOptionLabel={showOptionLabel}
    roomListId={roomListId}
    roomPosition={roomPosition}
    rateListId={rateListId}
    cancellationPolicyContentOverride={cancellationPolicyContentOverride}
  />
}

export default PropertyRateOptionMerged
